import onlyNumber from './onlyNumber'
import onlyNumberWord from './onlyNumberWord'
import inputFilter from './inputFilter'
const install = Vue => {
  Vue.directive('onlyNumber', onlyNumber)
  Vue.directive('onlyNumberWord', onlyNumberWord)
  Vue.directive('inputFilter', inputFilter)
}
export default install